<template>
  <div class="text-tooltip">
    <el-tooltip class="item" effect="dark" :disabled="isShowTooltip" :content="content" placement="top" popper-class="text-tooltip-popper">
      <p class="over-flow wid190"  v-bind:class="rowHeight"   @mouseover="onMouseOver(refName)">
        <span :ref="refName">{{content||'-'}}</span>
      </p>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TextTooltip',
  props: {
    // 显示的文字内容
    content: {
      type: String,
      default: () => {
        return ''
      }
    },
    rowHeight:{
      type: String
    },
    // 外层框的样式，在传入的这个类名中设置文字显示的宽度
    className: {
      type: String,
      default: () => {
        return 'wid190'
      }
    },
    // 为页面文字标识（如在同一页面中调用多次组件，此参数不可重复）
    refName: {
      type: String,
      default: () => {
        return 'contentSpan'
      }
    }
  },
  data() {
    return {
      isShowTooltip: true
    }
  },
  methods: {
    onMouseOver() {
      let parentHeight = this.$refs['contentSpan'].parentNode.offsetHeight;
      let contentHeight = this.$refs['contentSpan'].offsetHeight;
      // 判断是否开启tooltip功能
      if (contentHeight>parentHeight) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    }
  }
}
</script>

<style scoped>
  .over-flow {
    word-break: break-all;
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical
  }
  .rowheight1{
    -webkit-line-clamp:1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .rowheight3{
    -webkit-line-clamp:3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .wid190 {
    width: auto;
    max-height:64px;
    height: auto;
  }
  p{
    margin: 0;
  }
</style>
<style>
  .text-tooltip-popper {
    max-width: 50%;
  }
</style>
